
import axios from "axios";
import { URL_BASE } from "../config/url-server";

const clientId = localStorage.getItem("client")
const accessToken = localStorage.getItem("token")

export const getProduct = async (productId) => {
    const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
    try {
      const response = await axios.get(URL_BASE+"product/get/"+productId, config)
      const product = response.data?.data || null;
      return product;
    } catch (error) {
      console.error("Error:", error);
      return null;
    }
  };

  

export const getList = async () => {
    const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
    try {
      const response = await axios.get(URL_BASE+"product/list", config);
      const listado = response.data?.data || null;
      return listado;
    } catch (error) {
      console.error("Error:", error);
      return null;
    }
  };

  

  export const insert = async (data) => {
    const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
    try {
      const response = await axios.post(URL_BASE+"product/insert", data, config)
      const success = response.data?.success || null;
      return success;
    } catch (error) {
      console.error("Error:", error);
      return false;
    }
  };


  export const update = async (data) => {
    const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
    try {
      const response = await axios.post(URL_BASE+"product/update", data, config)
      const success = response.data?.success || null;
      return success;
    } catch (error) {
      console.error("Error:", error);
      return false;
    }
  };




  export default{
    getProduct,
    getList,
    insert,
    update
  }

